export default "__VITE_PUBLIC_ASSET__338c496a__"